import type { ListingRef } from './types';
import type { MappingSuggestionRow } from './suggestion-types';

/** The listing of a suggestion row, as the item picker and the create-item dialog read it. */
export const toListingRef = (row: MappingSuggestionRow): ListingRef => ({
  id: row.listingId,
  sku: row.sku,
  title: row.title,
  state: 'unmapped',
  unmappedReason: null,
});
